module.exports = __webpack_public_path__ + "img/b_unionbankofnigeria@2x.30e0edc5.png";